import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import UserLayout from '../../components/layouts/UserLayout';
import { fetchDownloadables } from '../../store/actions/downloadablesActions';
import Loader from '../../components/elements/Loader';
import DownloadableCard from '../../components/partials/downloads/DownloadableCard';
import Pagination from '../../components/elements/Pagination';
import EmptyState from '../../components/elements/EmptyState';

const Downloadables = () => {
    const dispatch = useDispatch()
    const downloadablesSelector = useSelector(state => state.downloadables)
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(25);

    useEffect(() => {
        dispatch(fetchDownloadables('', page, perPage))

        return () => {
            
        };

    }, [dispatch, page, perPage, downloadablesSelector.createdDownloadable, downloadablesSelector.updatedDownloadable, downloadablesSelector.deletedDownloadable]);

    return (
        <>
            <UserLayout>
                <div className='w-full'>
                    <div className='w-full flex justify-between'>
                        <div className='w-full xl:w-9/12'>
                            <h3 className='text-lg font-medium'>Vaatia College Downloadables</h3>
                            <p className='text-sm'>Downloadables are documents or other general media made available to users of this platform to download at any time. Once created, they can be pulled and displayed on the website, parents portal or have their links shared directly.</p>
                        </div>
                        
                        <div>
                            {/* <button onClick={()=>{setCreatingDownloadable(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                            <PlusIcon className='w-5 h-5' /> Create Downloadable
                            </button> */}
                        </div>
                    </div>

                    {downloadablesSelector.loadingDownloadables
                    ? 
                        <Loader /> 
                    :
                        downloadablesSelector?.downloadables?.downloadables?.length > 0 ? <>
                            <div className='w-full xl:w-9/12 2xl:w-7/12 mx-auto gap-[10px] mt-[50px]'>
                                {downloadablesSelector?.downloadables?.downloadables?.map((downloadable, downloadableIndex) => (
                                    <div key={downloadableIndex} className='w-full pb-[15px] mb-[15px] border-b'>
                                        <DownloadableCard 
                                            downloadable={downloadable} 
                                        />
                                    </div>
                                ))}
                            </div>

                            <Pagination 
                                pagination={{
                                    perPage, 
                                    page,
                                    totalItems: downloadablesSelector?.downloadables?.total,
                                }} 
                                changePage={setPage} 
                                updatePerPage={setPerPage}
                            />
                        </>
                        : 
                        <div className='mt-12'>
                            <EmptyState
                                emptyStateText={`No downloadables created yet. Please create some by clicking the "Create Downloadable" button above`}
                            />
                        </div>
                    }
                </div>
            </UserLayout>
        </>
    )
}

export default Downloadables